module.exports = __webpack_public_path__ + "static/media/Burundi.d9fa8c7e.png";